import React, { FC } from 'react';
import pluralize from 'pluralize';

import * as stylesGlobal from '@/styles';
import { ItemHeader, SearchSettingsDropdown } from '@/components/primitive';

import { testIds } from '../constants';

import * as stylesSearch from './styles';

type SearchStatusBarProps = {
  total: number | undefined;
  isLoading: boolean;
};

const SearchStatusBar: FC<SearchStatusBarProps> = ({ total, isLoading }) => (
  <div css={stylesGlobal.flexSpace} data-testid={testIds.searchStatusBar}>
    <h2>Advanced Search</h2>
    <div css={[stylesGlobal.flexCenter, stylesGlobal.spaceGapCozy]}>
      <ItemHeader
        css={[stylesGlobal.flex, stylesGlobal.spaceGapMinimum, stylesSearch.searchStatusBarStyles]}
      >
        {isLoading && <>loading results</>}
        {!isLoading && (
          <>
            <span>{total || 'no'}</span>
            <span>{pluralize('result', total)}</span>
            {!!total && <span>found</span>}
          </>
        )}
      </ItemHeader>
      <SearchSettingsDropdown />
    </div>
  </div>
);

export default SearchStatusBar;
